import getGraphQlClient from '~graphql/getGraphQlClient';
import { FETCH_AI_CREDITS_ORDERS } from '../queries/ai_credits';
import { unmarshalGraphqlResponse } from '~graphql/utils';

export const fetchAiCreditsOrders = async () => {
  const graphQlClient = await getGraphQlClient();

  const result = await graphQlClient.query({
    query: FETCH_AI_CREDITS_ORDERS,
    fetchPolicy: 'network-only',
  });

  const credits = await unmarshalGraphqlResponse(
    result.data,
    'findRemovebgOrders'
  );

  return credits;
};
